import { RiskType } from "../types"

// Get the RiskType from the value
export const getRiskTypeFromValue = (value: string) => {
  const entries = Object.entries(RiskType)
  const entry = entries.find(([key, val]) => val === value)
  return entry ? (entry[1] as RiskType) : undefined
}
